import ErrorState from './ErrorState';

export default ErrorState;
